import request from '@/API/';

export default {
  getGlobalEvents: (payload) => {
    return request.get(`data/global?f=${payload.startDate}&t=${payload.endDate}`);
  },
  getEventsData: (payload) => {
    if(!payload.app && !payload.interface) {
      return request.get(`data/events?q=${payload.q || ''}&f=${payload.startDate}&t=${payload.endDate}&c=${payload.client}&o=${payload.o || 0}&l=${payload.l}`);
    }
    else if(!payload.interface) {
      return request.get(`data/events?q=${payload.q || ''}&f=${payload.startDate}&t=${payload.endDate}&c=${payload.client}&o=${payload.o || 0}&l=${payload.l}&a=${payload.app}`);
    }
    else {
      return request.get(`data/events?q=${payload.q || ''}&f=${payload.startDate}&t=${payload.endDate}&c=${payload.client}&o=${payload.o || 0}&l=${payload.l}&a=${payload.app}&i=${payload.interface}`);
    }
  },
};
